import { render, staticRenderFns } from "./EndorsementRefundPayoutDetails.vue?vue&type=template&id=71844ec8"
import script from "./EndorsementRefundPayoutDetails.vue?vue&type=script&lang=js"
export * from "./EndorsementRefundPayoutDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports